import React from "react";
// import { Button } from "@material-ui/core";
// import { makeStyles } from "@material-ui/core/styles";
import { addSaleModal } from "../../redux/actions/sidebar/sidebarAction";
import { store } from "../../redux/storeConfig/store";
import { history } from "../../app/AppRouter";
import { useSelector } from "react-redux";
import { toggleSettlePaymentModal } from "../../redux/actions/class/classAction";
import { voiceReviewActionLabel } from "../voiceAdd/saveDraftEdit";

export const StepButton = (props) => {
  const { addToBookingListModal, bookAppointmentModal,settlePaymentModal } = useSelector(
    (state) => state.class
  );
  return (
    <>
      <div className="bg-white card-panel ex-space-y pt-0">
        <div className="action-wrapper blk-padding-y">
          <div className="action-inner-block">
            <div className="action-btn-block">
              <button
                className="btn btn-medium btn-transparent"
                type="button"
                onClick={() => {
                  if (props.upgradeSale) {
                    props.toggle()
                  } else {
                    store.dispatch(addSaleModal(false));
                    if (addToBookingListModal || bookAppointmentModal||settlePaymentModal)
                      store.dispatch(toggleSettlePaymentModal());
                  }
                }}
              >
                Cancel
              </button>
              <button
                value={props.upgradeSale?"Add Package":"Upgrade Package"}
                className="btn btn-medium"
                type="submit"
                disabled={props.disabled?props.disabled:false}
              >
                {voiceReviewActionLabel("Save")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
